export default __webpack_public_path__ + "static/media/science_img06.14b43654.png";